import React from "react";
import { Link } from "gatsby";
import resolveLink from "src/utils/resolveLink";

const Breadcrumbs = ({ blok }) => {
  return (
    <div className="max-w-[1440px] lg:px-16 px-6 bg-white my-12 mx-auto">
        {blok.breadcrumbs?.map((item, index) => {
          return (
            <Link
              className={`text-base leading-loose font-display uppercase hover:text-red duration-300 transition-colors ${
                index === blok.breadcrumbs.length - 1
                  ? "text-red"
                  : "text-darkgrey"
              }`}
              key={index}
              to={resolveLink(item.pathname)}
            >
              {item.crumbLabel.replace(/-/g, " ").replace(/_/g, " ")}
              {index < blok.breadcrumbs.length - 1 ? (
                <i className="fas fa-chevron-right cursor-pointer mx-3 text-xs inline !text-darkgrey"></i>
              ) : (
                ""
              )}
            </Link>
          );
        })}
    </div>
  );
};

export default Breadcrumbs
